import { MenuManager as HeaderMenuManager } from "./header/MenuManager.js";
import { MenuManager as FooterMenuManager } from "./footer/MenuManager.js";
import { SliderManager } from "./components/SliderManager.js";
import { ExpandableManager } from "./components/ExpandableManager.js";
import { Lightbox } from "./components/Lightbox.js";

// TCA Content Elements:
// import { Hero } from "./content/Hero.js";
import { ContentSlider } from "./content/ContentSlider.js";
import { LogoSlider } from "./content/LogoSlider.js";
import { Collapsible } from "./content/Collapsible.js";
// import { Benefits } from "./content/Benefits.js";
// import { Text } from "./content/Text.js";
import { TextMedia } from "./content/TextMedia.js";
import { Media } from "./content/Media.js";
import { Contact } from "./content/Contact.js";
import { TeaserImage } from "./content/TeaserImage.js";
import { TeaserSlider } from "./content/TeaserSlider.js";
import "./content/TextMedia.ts";
import "./content/Media.ts";
import "./content/Benefits.js";
import "./content/Collapsible.js";
import "./content/Hero.js";
import "./content/News.ts";
import "./content/ContentSlider.ts";
import "./content/Text.ts";

// Microsites:
import "./microsites/General.ts";
import "./microsites/Preis.ts";
import "./microsites/Aalto-preis.ts";
import "./microsites/Meinquartier.ts";

SliderManager.use();
HeaderMenuManager.use();
FooterMenuManager.use();
ExpandableManager.use();
new Lightbox();
